// Aligns a wellbeing-metric trend onto the weather trend's period labels so
// both can be drawn on one dual-axis chart. Weather is the spine (its x-axis
// label is the ISO day, e.g. "2026-06-01"); the metric value for each day is
// looked up from the metric trend rows by `period_start` (also the ISO day) -
// NOT the human `label` ("Mon, Jun 1"), which would never match. Days with no
// matching metric row get `metric: null` so the line connects across gaps.

export interface WeatherTrendInput {
  label: string;
  temperature: number | null;
  precipitation: number | null;
}

export interface WeatherMetricPoint {
  // Index signature so the row is assignable to the chart's dataset type.
  [key: string]: string | number | null;
  label: string;
  temperature: number | null;
  precipitation: number | null;
  metric: number | null;
}

export function mergeWeatherMetricSeries(
  weather: WeatherTrendInput[],
  metricTrend: Array<Record<string, unknown>>,
  metricId: string,
): WeatherMetricPoint[] {
  const byDay = new Map<string, number>();
  for (const row of metricTrend) {
    const day = (row.period_start ?? row.label) as string | undefined;
    if (!day) continue;
    const raw = row[metricId];
    if (typeof raw === 'number' && Number.isFinite(raw)) byDay.set(day, raw);
  }
  return weather.map((w) => ({
    label: w.label,
    temperature: w.temperature,
    precipitation: w.precipitation,
    metric: byDay.has(w.label) ? (byDay.get(w.label) as number) : null,
  }));
}
